import React, { useState, useEffect, useRef } from "react";
import Link from "next/link";
import '../styles/_agent-installation.module.scss';

type FeatureButton = {
    text: string;
    link: string;
};

type ProductFeature = {
    title: string;
    link: string;
    icon: React.ReactNode;
};

type Props = {
    productReadyToStart: ProductFeature[];
}

const ProductReadyToStart: React.FC<Props> = ({ productReadyToStart }) => {


    return (
        <section className="product-ready-to-start">
            <div className="container">
                <div className="section-tag">Ready to start?</div>
                <h2>Pick the path that <br /> matches your environment</h2>

                <div className="d-flex">
                    {productReadyToStart.map((item, index) => (
                        <div className="ready-to-card" key={index}>
                            <div className="info">
                                <div className="icon">{item.icon}</div>
                                <p>{item.title}</p>
                            </div>
                            <Link href={item.link} className="read-more">
                                Guide
                            </Link>
                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
};

export default ProductReadyToStart;
